module.exports = __webpack_public_path__ + "media/images/p-about/partner/京都北都信用金庫-13c35fcac5d1a6d1a61fef2c34de3fdf.PNG";